import type { SanityPageBuilderLinkListItem, SanityPageBuilderLinkListSection, SanityPageBuilderSection } from "@ouster/shared";
import { LinkListBlockView } from "~/features/blocks/inventory/link-list";
import { LinkListLinkView, type LinkListLinkViewProps } from "~/features/blocks/inventory/link-list/link-list-link";
import { toCraftLinkArray } from "~/features/sanity/link";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderLinkListSection;
  };
};
type LinkListViewItem = LinkListLinkViewProps & Pick<SanityPageBuilderLinkListItem, "_key">;
export function SanityLinkListSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const items = sectionContent.items?.map<LinkListViewItem>(item => ({
    _key: item._key,
    link: toCraftLinkArray(item.link),
    title: item.title
  })) ?? [];
  return <LinkListBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getItemKey={(item, index) => item._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} items={items} mode={sectionSettings?.mode || "light"} renderItem={item => <LinkListLinkView {...item} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}